import cloneDeep from "lodash/cloneDeep"
import { payloadTemplate } from "modules/cart"
import { GENDER_CORPORATION } from "modules/customers"
import { PROMOTION_TYPE_MANUAL_ACTIVITY } from "modules/discounts"
import {
  ES_PLAN_FIXED_AMOUNT_OPTION_1,
  ES_PLAN_FIXED_AMOUNT_OPTION_2,
  PAYMENT_TYPE_CREDIT_CARD_CASH,
  PAYMENT_TYPE_GOGORO_WALLET,
  PAYMENT_TYPE_LOAN,
  PAYMENT_TYPE_ONLINE_CREDIT_CARD,
  PAYMENT_TYPE_QRPAY,
  PAYMENT_TYPE_RECEIVABLES,
} from "modules/payment"
import {
  DEFAULT_SUBSIDY_UNIT_FOR_CORPORATION,
  DEFAULT_SUBSIDY_UNIT_FOR_PERSON,
  SUBSIDY_TYPE_LOCAL_ONLY,
  SUBSIDY_TYPE_NONE,
  SUBSIDY_TYPE_TES_AND_LOCAL,
  SUBSIDY_TYPE_TES_ONLY,
} from "modules/subsidies"
import { FEDERATION_GLB } from "views/constants/jsonData/globalData"
import * as orderData from "views/constants/jsonData/orderScooterData"
import { getLicenseServiceFee, getPickNumberServiceFee } from "views/Order/completed-utils"

export const initPersonalData = {
  Id: undefined,
  Name: undefined,
  Gender: 3,
  Email: undefined,
  IDCard: undefined,
  Mobile: undefined,
  State: undefined,
  StateId: undefined,
  City: undefined,
  CityId: undefined,
  District: undefined,
  DistrictId: undefined,
  ZipCode: undefined,
  Village: undefined,
  VillageId: undefined,
  Address: undefined,
  Birthday: [0, 0, 0],
}

export const initBirthday = "1970-1-1"

export const formatPersonalData = (initData, birthDay) => {
  return {
    Id: initData.Id,
    LastName: initData.LastName,
    FirstName: initData.FirstName,
    Name: initData.Name || `${initData.Gender === GENDER_CORPORATION ? "" : initData.LastName}${initData.FirstName}`,
    Gender: initData.Gender,
    Email: initData.EMail || initData.Email,
    IDCard: initData.IDCard ? initData.IDCard : "",
    Mobile: initData.Mobile && initData.Mobile?.replace(/^886-/, ""),
    State: initData.State,
    City: initData.City,
    District: initData.District,
    ZipCode: initData.ZipCode,
    Village: initData.Village,
    Address: initData.Address,
    Birthday: [birthDay.getFullYear(), birthDay.getMonth() + 1, birthDay.getDate()],
  }
}

export const getModifyData = (data, modifyData, winner) => {
  const initBuyer = modifyData.CustomerList.find((obj) => obj.Type === 1)
  const initGift = modifyData.CustomerList.find((obj) => obj.Type === 2)
  const initOwner = modifyData.CustomerList.find((obj) => obj.Type === 3)
  const initDriver = modifyData.CustomerList.find((obj) => obj.Type === 4) || initBuyer
  const buyerBirthday = new Date(initBuyer.Birthday)
  const ownerBirthday = new Date(initOwner.Birthday)
  const driverBirthday = new Date(initDriver.Birthday)
  const initRecommender = modifyData.RecommendData || false
  const scooterProductNo = modifyData.ProductList.find((item) => item.Type === 1).ProductNo
  const orderDate = modifyData.OrderDate
  const firstPaymentDate = modifyData.FirstPaymentDate
  const licenseServiceFee = getLicenseServiceFee(modifyData.ProductList)
  const pickNumberServiceFee = getPickNumberServiceFee(modifyData.ProductList)

  const result = {
    orderNo: modifyData.OrderNo,
    currentPath: winner ? "winner" : "modify",
    currentScooter: modifyData.ProductGroupList.find((group) => group.Type === 0).Product,
    corporateCarIndividualLicense: modifyData.OrderType === 2 ? 1 : 0,
    orderFormNoModify: modifyData.OrderVersion === 1,
    documentFee: modifyData.DocumentFee,
    isCrossCityIssueInvoice: modifyData.IsCrossCityIssueInvoice,
    companyIdentity: modifyData.CompanyIdentity,
    remaining: {
      licenseType: modifyData.ScooterData.LicenseType,
      scooterProductNo: scooterProductNo,
      isReceiveAward: modifyData.IsReceiveAward,
      orderDate,
      firstPaymentDate,
      vin: modifyData.ScooterData.Vin,
    },
    UserData: {
      Id: initOwner.UserId,
      Name: initOwner.Name,
      Gender: initOwner.Gender,
      Email: initOwner.Email,
      IDCard: initOwner.IDCard ? initOwner.IDCard : "",
      Mobile: initOwner.Mobile,
      State: initOwner.State,
      StateId: null,
      City: initOwner.City,
      CityId: null,
      District: initOwner.District,
      DistrictId: null,
      ZipCode: initOwner.ZipCode,
      Village: initOwner.Village,
      VillageId: null,
      Address: initOwner.Address,
      Birthday: [ownerBirthday.getFullYear(), ownerBirthday.getMonth() + 1, ownerBirthday.getDate()],
    },
    ShoppingCartData: {
      ...data.ShoppingCartData,
      Product: modifyData.ProductGroupList,
    },
    ProductList: modifyData.ProductList,
    allFormData: {
      ShoppingList: {
        ChannelName: modifyData.SalesChannelNo,
        ChannelArea: "",
        ChannelStore: modifyData.SalesChannelNo === "A" ? "" : modifyData.SalesStoreNo,
        ChannelNumber: modifyData.InvoiceNumbers,
        ChannelInvoiceDate: modifyData.InvoiceDate ? modifyData.InvoiceDate : null,
        EventName: modifyData.PromotionList.filter((item) => item.PromotionType === PROMOTION_TYPE_MANUAL_ACTIVITY).map(
          (item) => item.PromotionName,
        ),
        EventNameList: modifyData.PromotionList,
        PromotionSerials: modifyData.PromotionList.filter(
          (item) => item.PromotionType === PROMOTION_TYPE_MANUAL_ACTIVITY,
        ),
        CouponSerials: modifyData.CouponList?.filter((item) => item.CouponType === PROMOTION_TYPE_MANUAL_ACTIVITY),
      },
      OrderingInfo: {
        agreeForAccRule: true,
        ownerSameAsUser: false,
        OwnerName: initOwner.Name,
        OwnerFirstName: initOwner.FirstName,
        OwnerLastName: initOwner.LastName,
        OwnerGUINumber: initOwner.IDCard ? initOwner.IDCard : "",
        OwnerEmail: initOwner.Email,
        OwnerPhone: initOwner.Mobile?.replace(/^\+886/, ""),
        OwnerGender: initOwner.Gender,
        OwnerIDCard: initOwner.IDCard,
        OwnerState: initOwner.State,
        OwnerCity: initOwner.City,
        OwnerDistrict: initOwner.District,
        OwnerVillage: initOwner.Village,
        OwnerAddress: initOwner.Address,
        OwnerYear: ownerBirthday.getFullYear(),
        OwnerMonth: ownerBirthday.getMonth() + 1,
        OwnerDay: ownerBirthday.getDate(),
        OwnerPurchaseMethod: initOwner.PurchaseMethod,
        OwnerContact: initOwner.NickName,
        OwnerContactPhone: initOwner.HomePhone,
        driverSameAsUser: initDriver.Email === initBuyer.Email ? 1 : 2,
        BuyerName: initBuyer.Name,
        BuyerGender: initBuyer.Gender,
        BuyerIDCard: initBuyer.IDCard,
        BuyerEmail: initBuyer.Email,
        BuyerPhone: initBuyer.Mobile?.replace(/^886-/, ""),
        BuyerState: initBuyer.State,
        BuyerCity: initBuyer.City,
        BuyerDistrict: initBuyer.District,
        BuyerAddress: initBuyer.Address,
        BuyerYear: buyerBirthday.getFullYear(),
        BuyerMonth: buyerBirthday.getMonth() + 1,
        BuyerDay: buyerBirthday.getDate(),
        accountIsField: true,
        DriverName: initDriver.Name,
        DriverFirstName: initDriver.FirstName,
        DriverLastName: initDriver.LastName,
        DriverEmail: initDriver.Email ? initDriver.Email : undefined,
        PairingUserId: modifyData.ScooterData.PairingUserId,
        DriverYear: driverBirthday.getFullYear(),
        DriverMonth: driverBirthday.getMonth() + 1,
        DriverDay: driverBirthday.getDate(),

        // recommend
        hasRecommender: !!initRecommender,
        RecommendEmail: initRecommender ? initRecommender.Email : undefined,
        RecommendName: initRecommender ? initRecommender.Name : undefined,
        RecommendPhone: initRecommender ? initRecommender.Mobile : undefined,
        RecommendType: initRecommender ? initRecommender.LicensePlateType : undefined,
        RecommendLicense: initRecommender ? initRecommender.LicensePlate : undefined,
        RecommendSales: initRecommender ? initRecommender.RecommendSales : undefined,
        hasRecommenderPlus: modifyData.PromotionList.some((item) => item.ProjectCode === "EVT162"),

        winnerEmail: modifyData.IsReceiveAward ? initOwner.Email : "",
        winnerPhone: modifyData.IsReceiveAward ? initOwner.Mobile.substring(6) : "",
        agreeForAdventure: true,
        RecipientName: initGift ? initGift.Name : undefined,
        RecipientPhone: initGift ? initGift.Mobile : undefined,
        RecipientState: initGift ? initGift.State : undefined,
        RecipientCity: initGift ? initGift.City : undefined,
        RecipientDistrict: initGift ? initGift.District : undefined,
        RecipientAddress: initGift ? initGift.Address : undefined,
      },
      SubsidyLicensing: {
        agreeForSubsidy: true,
        OwnerCivilServants: initOwner.CivilServants,
        isAgreeLiability: true,
        LicensingState: modifyData.ScooterData.LicensingStatus,
        LicensingSite: modifyData.LicensingOrder
          ? modifyData.LicensingOrder.Name
          : modifyData.ScooterData.LicensingLocation,
        LicensingSiteId: modifyData.LicensingOrder
          ? modifyData.LicensingOrder.LicensingSiteId
          : modifyData.ScooterData.LicensingLocation,
        PickNumberType: modifyData.LicensingOrder?.PickNumberType || modifyData.ScooterData?.PickNumberType,
        PickNumberRemark: modifyData.LicensingOrder?.PickNumberRemark || modifyData.ScooterData?.PickNumberRemark,
        LicenseServiceFee: licenseServiceFee,
        PickNumberServiceFee: pickNumberServiceFee,
        InsuranceYear: modifyData.ScooterData.InsuredYears ? modifyData.ScooterData.InsuredYears : 2,
        SealType: modifyData.ScooterData.Stamp,
        ChooseLicensing: modifyData.LicensingOrder?.PickNumberType === "None" ? 0 : 1,
        AgencyFees: modifyData.ScooterData.AgencyFees,
        DocumentFeePayer: modifyData.DocumentFeePayer,
        agreeForCarRegistration: modifyData.ScooterData.LicensingStatus === 2 || null,
        DeliverStore: modifyData.ScooterData.PDIStore,
        BeDeprecatedSamePerson: modifyData.ScooterData.BeDeprecatedSamePerson,
        isAgreeInsuranceEvent: [],
        scooterRecycling: modifyData.ScooterData.ScooterRecycling,
        UBIAgree: modifyData.UBIAgree,
        UBIContact: ["UBIContact1", "UBIContact2"].filter((item) => modifyData[item]),
        UBIDescription: ["UBIDescription1", "UBIDescription2"].filter((item) => modifyData[item]),
      },
      SubsidyData: {
        subsidyType: modifyData.ScooterData.SubsidyType === 0 ? 0 : 1,
        identityTypeId: modifyData.TesSubsidyOrder
          ? modifyData.TesSubsidyOrder.IdentityTypeId
          : initOwner.Gender === GENDER_CORPORATION
            ? DEFAULT_SUBSIDY_UNIT_FOR_CORPORATION
            : DEFAULT_SUBSIDY_UNIT_FOR_PERSON,
        subsidyUnit: modifyData?.TesSubsidyOrder?.TesSubsidyTypeId,
        subsidyCounty: null,
        subsidyCountyName: modifyData.LocalSubsidyOrder
          ? modifyData.LocalSubsidyOrder.LocalSubsidyCityName
          : modifyData.ScooterData.SubsidyCounty || initOwner.City,
        localSubsidySelected: getSelectedSubsidy(modifyData.LocalSubsidyOrder, modifyData.ScooterData.SubsidyType),
        localSubsidyType: modifyData.LocalSubsidyOrder ? modifyData.LocalSubsidyOrder.LocalSubsidyTypeId : null,
        localSubsidyName: modifyData.LocalSubsidyOrder ? modifyData.LocalSubsidyOrder.Name : "",
        entrust: modifyData.LocalSubsidyOrder ? modifyData.LocalSubsidyOrder.EnTrust : null,
      },
      PaymentInfo: { ...getPayType(modifyData.PaymentList, winner), isAgreeInsuranceEvent: ["f"] },
    },
  }

  return result
}

const getSelectedSubsidy = (LocalSubsidyOrder, subsidyType) => {
  const subsidySelected = []

  if (LocalSubsidyOrder && LocalSubsidyOrder.IsEPA) {
    subsidySelected.push("IsEPA")
  }
  if (LocalSubsidyOrder && LocalSubsidyOrder.IsEPB) {
    subsidySelected.push("IsEPB")
  }
  if ([SUBSIDY_TYPE_TES_ONLY, SUBSIDY_TYPE_TES_AND_LOCAL].includes(subsidyType)) {
    subsidySelected.push("IsTES")
  }

  return subsidySelected
}

const getPayType = (paymentList, winner) => {
  const payData = {
    payType: undefined,
    loanDownPayment: 0,
    loanIsInterest: 1,
    loanIsGuarantor: 0,
    loanSameAsOwner: true,
    onlinePayment: null,
    onlineCardNum: undefined,
    onlineCardMonth: undefined,
    onlineCardYear: undefined,
    onlineCardCVC: undefined,
  }
  if (winner) {
    payData.payType = orderData.payTypeOption[0]
  } else {
    switch (paymentList.length && paymentList[0].Type) {
      case PAYMENT_TYPE_ONLINE_CREDIT_CARD:
        payData.paymentListType = paymentList[0].Type
        payData.payType = orderData.payTypeOption[2]
        payData.onlinePayment =
          paymentList[0].PaymentCreditCardData.Period === 0 ? 1 : paymentList[0].PaymentCreditCardData.Period
        payData.onlineCardNum = paymentList[0].PaymentCreditCardData.CardNo
        payData.onlineCardMonth = paymentList[0].PaymentCreditCardData.Month
        payData.onlineCardYear = paymentList[0].PaymentCreditCardData.Year
        payData.onlineCardCVC = paymentList[0].PaymentCreditCardData.SecurityCode
        payData.paymentMethod = paymentList[0].Method
        break
      case PAYMENT_TYPE_LOAN:
        const loanData = paymentList[0].PaymentLoanData
        const {
          DownPayment = 0,
          LoanId,
          Period,
          HandlingFee,
          PeriodAmount,
          InterestRate,
          CoSigner,
          IsBorrowerSameOwner,
          PeriodIndex,
          IsScooterAmountEnable,
          IsAccessoryAmountEnable,
          IsEsPlanAmountEnable,
          EsPlanAmount,
        } = loanData
        payData.paymentListType = paymentList[0].Type
        payData.payType = orderData.payTypeOption[1]
        payData.loanDownPayment = DownPayment
        payData.loanCompanyId = LoanId
        payData.selectedLoanOption = {
          Term: Period,
          HandlingFee: HandlingFee,
          InstallmentAmount: PeriodAmount,
          Rates: [{ Rate: InterestRate }],
        }
        payData.loanIsInterest = 1 // always has interest
        payData.loanIsGuarantor = CoSigner
        payData.loanSameAsOwner = IsBorrowerSameOwner
        payData.loanPaymentIndex = PeriodIndex
        payData.isScooterAmountEnable = IsScooterAmountEnable
        payData.isAccessoryAmountEnable = IsAccessoryAmountEnable
        payData.isEsPlanAmountEnable = IsEsPlanAmountEnable
        payData.esPlanAmount = IsEsPlanAmountEnable ? EsPlanAmount : 0
        if (!IsEsPlanAmountEnable) {
          payData.esPlanLoanItem = 1
        } else {
          switch (EsPlanAmount) {
            case ES_PLAN_FIXED_AMOUNT_OPTION_1:
              payData.esPlanLoanItem = 1
              break
            case ES_PLAN_FIXED_AMOUNT_OPTION_2:
              payData.esPlanLoanItem = 2
              break
            default:
              payData.esPlanLoanItem = 3
              payData.customEsPlanAmount = EsPlanAmount
          }
        }
        break
      case PAYMENT_TYPE_RECEIVABLES:
        payData.payType = orderData.payTypeOption[3]
        payData.receivablesPayment = paymentList[0].PaymentReceivablesData.OtherAmountType
        break
      case PAYMENT_TYPE_QRPAY:
        payData.paymentListType = paymentList[0].Type
        payData.payType = orderData.payTypeOption[4]
        break
      case PAYMENT_TYPE_GOGORO_WALLET:
        payData.paymentListType = paymentList[0].Type
        payData.payType = orderData.payTypeOption[4]
        payData.installmentPlan = paymentList[0].PaymentGogoroWalletData
        break
      case PAYMENT_TYPE_CREDIT_CARD_CASH:
      default:
        payData.payType = orderData.payTypeOption[0]
        payData.paymentListType = PAYMENT_TYPE_CREDIT_CARD_CASH
        break
    }
  }
  return payData
}

export const getCurrentAmount = function (prodcuts) {
  const comboArr = prodcuts.filter((obj) => obj.Type !== 0)
  const comboAmount = comboArr.length
    ? comboArr.reduce(
        (total, combo) => (total += combo.Product.reduce((subtotal, pro) => (subtotal += pro.Subtotal), 0)),
        0,
      )
    : 0
  const comboDiscountAmount = comboArr.length
    ? comboArr.reduce(
        (total, combo) =>
          (total += combo.Product.reduce((discountTotal, pro) => (discountTotal += pro.DiscountAmount), 0)),
        0,
      )
    : 0
  const scooterPro = prodcuts.length ? prodcuts.filter((obj) => obj.Type === 0)[0].Product : []
  const scooterAmount = calcProductAmountByType(scooterPro, 1)
  const productAmount = calcProductAmountByType(scooterPro, 4) + comboAmount
  const discountAmount = scooterPro.reduce((total, val) => total + val.DiscountAmount, 0) + comboDiscountAmount

  return {
    comboAmount, // 折扣後 combo 總價
    productAmount, // 折扣後 combo + 配件 總價
    scooterAmount, // 折扣後 scooter 價格
    lastTotalAmount: scooterAmount + productAmount + discountAmount, // 折扣前 商品總價 不含文件處理費
    documentFee: calcProductAmountByType(scooterPro, 5), // 文件處理費
    totalAmount: scooterAmount + productAmount, // 折扣後商品總價 不含文件處理費
    discountAmount, // 總折扣金額 為正數
  }
}

const calcProductAmountByType = (product, type) =>
  product.map((obj) => (obj.Type === type ? obj.Subtotal : 0)).reduce((total, val) => total + val, 0)

export const formatPostData = (userState, globalUi, orderScooter, scooter) => {
  const { getPartnerStore } = globalUi
  const {
    ShoppingCartData,
    UserData,
    allFormData: { ShoppingList, OrderingInfo, SubsidyLicensing, PaymentInfo, SubsidyData },
    licensingCenterOptions,
    corporateCarIndividualLicense,
    remaining,
  } = orderScooter
  const data = cloneDeep(payloadTemplate)
  const allAmount = getCurrentAmount(ShoppingCartData.Product)
  const TotalAmount = allAmount.totalAmount + allAmount.documentFee

  data.Bag = 1
  data.IsReceiveAward = orderScooter.currentPath === "winner" ? 1 : -1
  // 1:一般訂單 2:法人贈車
  data.OrderType = corporateCarIndividualLicense ? 2 : 1
  data.UserId = UserData.Id
  // 員工編號
  data.EmployeeNo = userState.userData?.UserId
  if (PaymentInfo.UserID) {
    data.CheckEmployeeNo = PaymentInfo.UserID.toUpperCase()
  }

  if (orderData.TELECOM_CHANNELS.includes(ShoppingList.ChannelName)) {
    data.SalesChannelNo = orderData.GOGORO_STORE_CHANNEL
  } else {
    // 門市通路
    data.SalesChannelNo = ShoppingList.ChannelName || orderData.GOGORO_STORE_CHANNEL
  }
  const salesChannel = getPartnerStore?.Partners?.find((obj) => obj.SalesTypeId === ShoppingList.ChannelName)
  data.SalesChannelName = salesChannel ? salesChannel.Name : "Gogoro 門市"

  if (ShoppingList.ChannelStore && ShoppingList.ChannelName !== orderData.GOGORO_STORE_CHANNEL) {
    data.SalesStoreNo = ShoppingList.ChannelStore

    if (ShoppingList.ChannelName !== "P") {
      const areaArr = salesChannel.Districts
      const area = areaArr.find((obj) => obj.Stores.some((store) => store.Id === ShoppingList.ChannelStore))
      const ChannelArea = area ? area.Name : ShoppingList.ChannelArea
      const storeArr = areaArr.find((obj) => obj.Name === ChannelArea).Stores

      data.SalesStoreName = storeArr.find((obj) => obj.Id === ShoppingList.ChannelStore).Name
    }
  }

  if (ShoppingList.ChannelNumber) {
    data.Invoice.Numbers =
      ShoppingList.ChannelName === orderData.FACILITATING_CHANNEL
        ? ShoppingList.ChannelNumber.toUpperCase()
        : ShoppingList.ChannelNumber
  }
  data.Invoice.Date = ShoppingList.ChannelInvoiceDate ? ShoppingList.ChannelInvoiceDate : null

  const CHINESE_REGEX = /(\p{Script=Hani})+/gu // note the 'u'

  data.Buyer = {
    Email: UserData.Email,
    Name: UserData.Name,
    FirstName: UserData.FirstName,
    LastName: UserData.LastName,
    Gender: UserData.Gender,
    // IDCard: UserData.IDCard,
    Mobile: UserData.Mobile,
    // Birthday: `${UserData.Birthday[0]}-${UserData.Birthday[1]}-${UserData.Birthday[2]}`,
    State: OrderingInfo.BuyerState,
    StateId: null,
    City: OrderingInfo.BuyerCity,
    CityId: null,
    District: OrderingInfo.BuyerDistrict,
    DistrictId: null,
    ZipCode: OrderingInfo.BuyerZipCode,
    Address: `${OrderingInfo.BuyerVillage ? OrderingInfo.BuyerVillage : ""}${OrderingInfo.BuyerAddress}`,
  }

  data.Owner = {
    Email: OrderingInfo.OwnerEmail,
    Name:
      OrderingInfo.OwnerGender === GENDER_CORPORATION
        ? OrderingInfo.OwnerName || OrderingInfo.OwnerFirstName
        : OrderingInfo.OwnerName ||
            CHINESE_REGEX.test(OrderingInfo.OwnerFirstName) ||
            CHINESE_REGEX.test(OrderingInfo.OwnerLastName)
          ? `${OrderingInfo.OwnerLastName}${OrderingInfo.OwnerFirstName}`
          : `${OrderingInfo.OwnerFirstName} ${OrderingInfo.OwnerLastName}`,
    FirstName: OrderingInfo.OwnerFirstName,
    LastName: OrderingInfo.OwnerLastName,
    Gender: OrderingInfo.OwnerGender,
    IDCard:
      OrderingInfo.OwnerGender === GENDER_CORPORATION
        ? OrderingInfo.OwnerGUINumber
        : OrderingInfo.OwnerIDCard?.toUpperCase(),
    Mobile: "+886" + OrderingInfo.OwnerPhone,
    Birthday:
      OrderingInfo.OwnerYear && OrderingInfo.OwnerMonth && OrderingInfo.OwnerDay
        ? `${OrderingInfo.OwnerYear}-${OrderingInfo.OwnerMonth}-${OrderingInfo.OwnerDay}`
        : initBirthday,
    NickName: OrderingInfo.OwnerContact,
    HomePhone: OrderingInfo.OwnerContactPhone,
    State: OrderingInfo.OwnerState,
    StateId: null,
    City: OrderingInfo.OwnerCity,
    CityId: null,
    District: OrderingInfo.OwnerDistrict,
    DistrictId: null,
    ZipCode: OrderingInfo.OwnerZipCode,
    Address: OrderingInfo.OwnerAddress,
    CivilServants: SubsidyLicensing.OwnerCivilServants,
    PurchaseMethod: OrderingInfo.OwnerPurchaseMethod,
  }

  data.Driver =
    OrderingInfo.driverSameAsUser === 0
      ? {}
      : (() => {
          // prevent the default account from filling back into driver info
          if (OrderingInfo.driverSameAsUser === 1) {
            return UserData?.Email === "order-system@gogoro.com"
              ? {}
              : {
                  Name: UserData.Name,
                  FirstName: UserData.FirstName,
                  LastName: UserData.LastName,
                  Email: UserData.Email,
                }
          }
          return OrderingInfo?.DriverEmail === "order-system@gogoro.com"
            ? {}
            : {
                Name:
                  OrderingInfo.DriverName ||
                  (CHINESE_REGEX.test(OrderingInfo.DriverFirstName || OrderingInfo.DriverLastName)
                    ? `${OrderingInfo.DriverLastName}${OrderingInfo.DriverFirstName}`
                    : `${OrderingInfo.DriverFirstName} ${OrderingInfo.DriverLastName}`),
                FirstName: OrderingInfo.DriverFirstName,
                LastName: OrderingInfo.DriverLastName,
                Email: OrderingInfo.DriverEmail,
              }
        })()
  data.Deliveries = {}
  data.DeliveryConditions = {
    Type: 2,
    StoreId: SubsidyLicensing.DeliverStore,
  }
  //SubsidyData
  const hasTesSubsidy = SubsidyData.localSubsidySelected?.includes("IsTES")
  const hasEpaSubsidy = SubsidyData.localSubsidySelected?.includes("IsEPA")
  const hasEpbSubsidy = SubsidyData.localSubsidySelected?.includes("IsEPB")
  let currentSubsidyType = SUBSIDY_TYPE_TES_AND_LOCAL

  if (SubsidyData.subsidyType === 0) {
    currentSubsidyType = SUBSIDY_TYPE_NONE
  } else if (!hasTesSubsidy) {
    currentSubsidyType = SUBSIDY_TYPE_LOCAL_ONLY
  } else if (!hasEpaSubsidy && !hasEpbSubsidy) {
    currentSubsidyType = SUBSIDY_TYPE_TES_ONLY
  }
  data.DocumentFeePayer = SubsidyLicensing.DocumentFeePayer ? SubsidyLicensing.DocumentFeePayer : 1

  const EmployeeStoreId = userState?.userData?.DepartmentCode
  data.Scooter = {
    PDIStoreId: SubsidyLicensing.DeliverStore || EmployeeStoreId,
    PairingAccount: OrderingInfo.DriverEmail || null,
    PairingUserId: OrderingInfo.PairingUserId || null,
    SingingDay: OrderingInfo.DriverYear
      ? `${OrderingInfo.DriverYear}-${OrderingInfo.DriverMonth}-${OrderingInfo.DriverDay}`
      : null,
    SubsidyType: currentSubsidyType,
    SubsidyApplication: hasEpaSubsidy || hasEpbSubsidy ? 2 : 1,
    SubsidyCounty: hasEpaSubsidy || hasEpbSubsidy ? SubsidyData.subsidyCountyName : "",
    BeDeprecatedSamePerson: SubsidyLicensing.BeDeprecatedSamePerson ?? null,
    Subsidy: {
      TesSubsidyTypeId: hasTesSubsidy ? SubsidyData.subsidyUnit : null,
      LocalSubsidyTypeId: hasEpaSubsidy || hasEpbSubsidy ? SubsidyData.localSubsidyType : null,
      IsTES: hasTesSubsidy,
      IsEPA: hasEpaSubsidy,
      IsEPB: hasEpbSubsidy,
      EnTrust: SubsidyLicensing.EntrustGogoroApply >= 0 ? SubsidyLicensing.EntrustGogoroApply : null,
    },
    Licensing: {
      LicensingStatus: SubsidyLicensing.LicensingState || 2, // 1: Gogoro 代領牌, 2: 自領牌
      LicensingLocation: licensingCenterOptions.find((option) => option.Id === SubsidyLicensing.LicensingSiteId)
        ? licensingCenterOptions.find((option) => option.Id === SubsidyLicensing.LicensingSiteId).Name
        : SubsidyLicensing.LicensingSiteId,
      LicensingLocationId: SubsidyLicensing.LicensingSiteId,
      InsuredYears: SubsidyLicensing.LicensingState === 1 ? SubsidyLicensing.InsuranceYear : 0,
      Stamp: SubsidyLicensing.SealType,
      PickNumberType: SubsidyLicensing.ChooseLicensing === 0 ? "None" : SubsidyLicensing.PickNumberType,
      PickNumberRemark: SubsidyLicensing.ChooseLicensing === 0 ? "" : SubsidyLicensing.PickNumberRemark,
      AgencyFees: SubsidyLicensing.AgencyFees,
    },
    LicenseType: remaining?.licenseType,
    // carry 0 when it's not depreciation
    ScooterRecycling:
      SubsidyData.localSubsidyName.includes("汰購") && (hasEpaSubsidy || hasEpbSubsidy)
        ? SubsidyLicensing.scooterRecycling
        : 0,
    Vin: scooter?.vin,
  }

  data.UBIAgree = SubsidyLicensing.UBIAgree
  data.UBIContact1 = SubsidyLicensing.UBIContact?.includes("UBIContact1")
  data.UBIContact2 = SubsidyLicensing.UBIContact?.includes("UBIContact2")
  data.UBIDescription1 = SubsidyLicensing.UBIDescription?.includes("UBIDescription1")
  data.UBIDescription2 = SubsidyLicensing.UBIDescription?.includes("UBIDescription2")

  // 付款資料
  // orderData.payTypeOption = ['現金、信用卡、匯款', '貸款', '線上刷卡', '通路付款', '永豐 QR 線上刷卡'];
  switch (PaymentInfo.payType) {
    case orderData.payTypeOption[0]: //現金、信用卡、刷卡
      data.Payment.Type = PAYMENT_TYPE_CREDIT_CARD_CASH
      data.Payment.IsPaymentChange = PaymentInfo.isPaymentChange
      delete data.Payment.CreditCard
      delete data.Payment.Loan
      delete data.Payment.Receivables
      delete data.Payment.GogoroWallet
      break
    case orderData.payTypeOption[1]: //貸款
      const loanDownPayment = PaymentInfo.loanDownPayment || 0
      data.Payment.Type = PAYMENT_TYPE_LOAN
      data.Payment.IsPaymentChange = PaymentInfo.isPaymentChange
      data.Payment.Loan = {
        Amount: PaymentInfo.totalLoanAmount,
        DownPayment: loanDownPayment,
        LoanId: PaymentInfo.loanCompanyId,
        LoanCompany: PaymentInfo.loanCompanyName,
        Interest: PaymentInfo.loanIsInterest,
        CoSigner: PaymentInfo.loanIsGuarantor,
        IsBorrowerSameOwner: PaymentInfo.loanSameAsOwner,
        Period: PaymentInfo.selectedLoanOption.Term,
        InterestRate: PaymentInfo.selectedLoanOption.Rates[0].Rate,
        PeriodAmount: PaymentInfo.selectedLoanOption.InstallmentAmount,
        PeriodIndex: PaymentInfo.loanPaymentIndex,
        HandlingFee: PaymentInfo.selectedLoanOption.HandlingFee,
        IsScooterAmountEnable: PaymentInfo.isScooterAmountEnable,
        IsAccessoryAmountEnable: PaymentInfo.isAccessoryAmountEnable,
        IsEsPlanAmountEnable: PaymentInfo.isEsPlanAmountEnable,
        EsPlanAmount: PaymentInfo.isEsPlanAmountEnable ? PaymentInfo.esPlanAmount : 0,
      }
      delete data.Payment.CreditCard
      delete data.Payment.Cash
      delete data.Payment.Receivables
      delete data.Payment.GogoroWallet
      break
    case orderData.payTypeOption[2]: //線上刷卡
      data.Payment.Type = PAYMENT_TYPE_ONLINE_CREDIT_CARD
      data.Payment.CreditCard = {
        Type: PaymentInfo.onlinePayment === 0 ? 1 : 3,
        Amount: TotalAmount,
        Period: PaymentInfo.onlinePayment === 1 ? 0 : PaymentInfo.onlinePayment,
        Month: PaymentInfo.onlineCardMonth,
        Year: PaymentInfo.onlineCardYear,
        SecurityCode: PaymentInfo.onlineCardCVC,
        CardNo: PaymentInfo.onlineCardNum,
      }
      delete data.Payment.Cash
      delete data.Payment.Loan
      delete data.Payment.Receivables
      delete data.Payment.GogoroWallet
      break
    case orderData.payTypeOption[3]: //通路付款
      data.Payment.Type = PAYMENT_TYPE_RECEIVABLES
      data.Payment.Receivables = {
        Amount: TotalAmount - allAmount.documentFee - allAmount.productAmount,
        OtherAmount: allAmount.documentFee + allAmount.productAmount,
        OtherAmountType: PaymentInfo.receivablesPayment,
      }
      delete data.Payment.CreditCard
      delete data.Payment.Cash
      delete data.Payment.Loan
      delete data.Payment.GogoroWallet
      break
    case orderData.payTypeOption[4]: //Gogoro Wallet
      data.Payment.Type = PAYMENT_TYPE_GOGORO_WALLET
      data.Payment.IsPaymentChange = PaymentInfo.isPaymentChange
      data.Payment.GogoroWallet = {
        QRCode: PaymentInfo?.QRCode,
        AuthorizedPaymentId: PaymentInfo?.AuthorizedPaymentId,
        // 建訂單的時候是存成string 放在Installment, get的時候是放在Object
        // **修改訂單的時候因不會再次取得installmentPlan 所以會是undefined
        Installment: PaymentInfo?.installmentPlan?.length
          ? parseInt(PaymentInfo?.installmentPlan?.split("_")[0], 10)
          : PaymentInfo.installmentPlan?.Installment,
        InstallmentAmount: PaymentInfo?.installmentPlan?.length
          ? PaymentInfo?.installmentPlan?.split("_")[1]
          : PaymentInfo.installmentPlan?.InstallmentAmount,
        InstallmentDescription: PaymentInfo?.installmentPlan?.length
          ? PaymentInfo?.installmentPlan?.split("_")[2]
          : PaymentInfo.installmentPlan?.InstallmentDescription,
      }
      delete data.Payment.Cash
      delete data.Payment.CreditCard
      delete data.Payment.Loan
      delete data.Payment.Receivables
      break
    case "永豐 QR 線上刷卡": //QRPAY
      data.Payment.Type = PAYMENT_TYPE_QRPAY
      delete data.Payment.Cash
      delete data.Payment.CreditCard
      delete data.Payment.Loan
      delete data.Payment.Receivables
      break
    default:
      // PH 環境的 payment methods 是從後端來的
      if (userState.userData.Federation === FEDERATION_GLB) {
        data.Payment.Type = PAYMENT_TYPE_ONLINE_CREDIT_CARD
        data.Payment.CreditCard = {
          Type: Number(PaymentInfo.payType),
          Amount: TotalAmount,
          Period: 0,
        }
        delete data.Payment.Cash
        delete data.Payment.Loan
        delete data.Payment.Receivables
        delete data.Payment.GogoroWallet
      }
      break
  }

  // 電馳發票
  data.Contract = {
    InvoicesGUINumbers: OrderingInfo.BatteryGUINumber,
    InvoicesTitle: OrderingInfo.BatteryGUIName,
  }

  data.Recommend = OrderingInfo.hasRecommender
    ? {
        Email: OrderingInfo.RecommendEmail,
        Name: OrderingInfo.RecommendName,
        Mobile: OrderingInfo.RecommendPhone,
        RecommendSales: OrderingInfo.RecommendSales,
        State: OrderingInfo.RecommendState,
        StateId: null,
        City: OrderingInfo.RecommendCity,
        CityId: null,
        District: OrderingInfo.RecommendDistrict,
        DistrictId: null,
        ZipCode: OrderingInfo.RecommendZipCode,
        Address: OrderingInfo.RecommendAddress,
        LicensePlateType: OrderingInfo.RecommendType,
        LicensePlate: OrderingInfo.RecommendLicense.toUpperCase(),
        UploadFileKey: OrderingInfo.UploadFileKey,
      }
    : {}
  data.ProjectActivity = getProjectActivity(orderScooter)
  data.Promotion = getPromotion(orderScooter)
  data.Coupon = getCoupon(orderScooter)
  data.Deliveries = {
    Name: OrderingInfo.RecipientName,
    Email: null,
    Mobile: OrderingInfo.RecipientPhone,
    State: OrderingInfo.RecipientState,
    StateId: null,
    City: OrderingInfo.RecipientCity,
    CityId: null,
    District: OrderingInfo.RecipientDistrict,
    DistrictId: null,
    ZipCode: OrderingInfo.RecipientZipCode,
    Address: OrderingInfo.RecipientAddress,
  }

  return data
}
// Promotion
const getPromotion = (orderScooter) => {
  const {
    allFormData: { ShoppingList },
  } = orderScooter
  return ShoppingList.PromotionSerials
}

const getCoupon = (orderScooter) => {
  const {
    allFormData: { ShoppingList },
  } = orderScooter
  return ShoppingList.CouponSerials
}

// 專案活動
const getProjectActivity = (orderScooter) => {
  const {
    allFormData: { ShoppingList: { EventNameList } = {} },
    currentPath,
  } = orderScooter
  if (EventNameList && EventNameList.length && currentPath !== "scooter") {
    return EventNameList
  }

  return []
}
